<app-loading-spinner *ngIf="isLoading" />

<div *ngIf="!isLoading" class="w-full px-10 py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg mt-6">
    <div class="flex flex-row items-center justify-end gap-8 ">
        <div class="flex items-center rounded-full  px-4 py-2 w-96 bg-[#F1F1F1] dark:bg-[#292929]">
            <input type="text" placeholder="Search by EMP ID, First / Last name" [(ngModel)]="searchText"
                class="bg-transparent outline-none w-full text-textLight dark:text-textDark" />
            <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none mr-2"
                (click)="onSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 10-14 0 7 7 0 0014 0z" />
                </svg>
            </button>
            <button type="button" class="text-gray-500 hover:text-gray-700 focus:outline-none" (click)="offSearch()">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    </div>

    <div *ngIf="hasData"
        class="overflow-x-auto mt-8 mr-5 border-gray-100 border-[2px] rounded-lg dark:border-[#202021]">
        <table class="w-full min-w-max divide-y-2 border-[1px] border-gray-300 rounded-lg overflow-hidden">
            <thead class=" text-gray-700 dark:text-gray-300 dark:bg-[#0F0F0F] dark:border-[#202021]">
                <tr>
                    <th class="px-5 py-3 text-left  font-medium">No</th>
                    <th class="px-5 py-3 text-left  font-medium">EMP ID</th>
                    <th class="px-5 py-3 text-left  font-medium">First Name</th>
                    <th class="px-5 py-3 text-left  font-medium">Last Name</th>
                    <th class="px-5 py-3 text-left  font-medium">Monthly Report</th>
                    <th class="px-5 py-3 text-left  font-medium">Daily Report</th>
                    <th class="px-5 py-3 text-left  font-medium">Farmers</th>
                </tr>
            </thead>
            <tbody class="bg-white dark:bg-[#1D1D1F] dark:border-[#1D1D1F]">
                <tr *ngFor="let item of OfficerArr | paginate
                : {
                    itemsPerPage: itemsPerPage,
                    currentPage: page,
                    totalItems: totalItems
                  };  let i = index">
                    <td class="px-5 py-4  text-gray-900 dark:text-gray-300">
                        {{ (((page - 1) * itemsPerPage) + i + 1) < 10 ? '0' + (((page - 1) * itemsPerPage) + i + 1) :
                            (((page - 1) * itemsPerPage) + i + 1) }} </td>
                    <td class="px-5 py-4  text-gray-900 dark:text-gray-300">{{item.empId}}</td>
                    <td class="px-5 py-4  text-gray-900 dark:text-gray-300">{{item.firstNameEnglish}}</td>
                    <td class="px-5 py-4  text-gray-900 dark:text-gray-300">{{item.lastNameEnglish}}</td>
                    <td class="px-5  py-4  text-gray-900 dark:text-gray-300">
                        <button class="flex items-center justify-center text-[#415CFF] hover:text-gray-600 w-10 h-10">
                            <i class="fa-solid fa-arrow-up-right-from-square text-lg"></i>
                        </button>
                    </td>
                    <td class="px-5 py-4  text-gray-900 dark:text-gray-300 ">
                        <button class="flex items-center justify-center text-[#415CFF] hover:text-blue-500 w-10 h-10">
                            <i class="fa-solid fa-arrow-up-right-from-square text-lg"></i>
                        </button>
                    </td>
                    <td class="px-5 py-4  text-gray-900 dark:text-gray-300">
                        <button class="flex items-center justify-center text-[#415CFF] hover:text-red-500 w-10 h-10">
                            <i class="fa-solid fa-arrow-up-right-from-square text-lg"></i>
                        </button>
                    </td>

                </tr>
            </tbody>
        </table>
    </div>
    <div *ngIf="hasData" class="flex items-center justify-end my-5 mr-5">
        <pagination-controls (pageChange)="onPageChange($event)" [responsive]="true" [previousLabel]="'Previous'"
            [nextLabel]="'Next'" [screenReaderPaginationLabel]="'Pagination'" [screenReaderPageLabel]="'page'"
            [screenReaderCurrentLabel]="'Youre on page'">
        </pagination-controls>
    </div>
</div>
